var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 10.6665C5.33334 6.89527 5.33334 5.00965 6.50491 3.83808C7.67648 2.6665 9.5621 2.6665 13.3333 2.6665H18.6667C22.4379 2.6665 24.3235 2.6665 25.4951 3.83808C26.6667 5.00965 26.6667 6.89527 26.6667 10.6665V21.3332C26.6667 25.1044 26.6667 26.99 25.4951 28.1616C24.3235 29.3332 22.4379 29.3332 18.6667 29.3332H13.3333C9.5621 29.3332 7.67648 29.3332 6.50491 28.1616C5.33334 26.99 5.33334 25.1044 5.33334 21.3332V10.6665Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5304 21.3335H10.5304C9.29041 21.3335 8.67043 21.3335 8.16176 21.4698C6.78139 21.8397 5.7032 22.9179 5.33334 24.2982",
    stroke: "#172B4D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 9.3335H21.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14H17.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 21.3335V26.0414C17.3333 26.4089 17.3333 26.5926 17.2069 26.6668C17.0804 26.7411 16.9074 26.6589 16.5615 26.4946L14.9052 25.7078C14.7881 25.6522 14.7296 25.6244 14.6667 25.6244C14.6037 25.6244 14.5452 25.6522 14.4282 25.7078L12.7718 26.4946C12.4259 26.6589 12.2529 26.7411 12.1265 26.6668C12 26.5926 12 26.4089 12 26.0414V21.9335",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/member-icon.76fa150a1690460f850f73841a2fc88d.svg";
export { ForwardRef as ReactComponent };